<div class="material-datatables">
  <table [id]="table_id" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%"
    style="width:100%">
    <thead>
      <tr>

        <th class="disabled-sorting"><b>Id</b></th>
        <th class="disabled-sorting"><b>PO</b></th>
        <th class="disabled-sorting"><b>Item Type</b></th>
        <th class="disabled-sorting"><b>NET Weight</b></th>
        <th class="disabled-sorting"><b>Damage</b></th>
        <th class="disabled-sorting"><b>Date Received</b></th>
        <!-- <th class="disabled-sorting text-right"><b>Actions</b></th> -->

      </tr>
    </thead>
    <tbody>
      <tr style="cursor: pointer;" *ngFor="let item of data">

        <td>{{item.id}}</td>
        <td>{{item.po.po}}</td>
        <td>{{item.item}}</td>
        <td>{{item.totalNetWeight}} Lbs</td>
        <td>{{item.damages}}</td>
        <td>{{item.createdAt | date:'MM-dd-yyyy' }}</td>
        <!--
        <td class="text-right">
          <a class="btn btn-link btn-info btn-just-icon like" (click)="saveEmit('show',item.id, item)">
            <i class="material-icons">remove_red_eye</i>
          </a>
          <a class="btn btn-link btn-danger btn-just-icon" (click)="saveEmit('delete',item.id, item)">
            <i class="material-icons">close</i>
          </a>
        </td>
        -->
      </tr>
    </tbody>

  </table>
</div>